function Title(props) {
    return(
      <h2 className="text-4xl max-sm:text-2xl font-bold my-6">
        {props.title}<span className="text-xl text-gray-500 font-semibold max-sm:text-lg mx-2">{props.text}</span>
     </h2>
    )
}
export default Title;
